
<script setup>
import {defineProps, defineEmits, ref, onBeforeMount} from "vue";

const props = defineProps({
  pagePerItems : {
    type : [String, Number],
    default : 10
  }});
const selectedOption = ref("");
const pageOption = [10,30,50,100];
const emit = defineEmits([
  "set_pageSize"
]);
const updateNumItems  = (e)=>{
  emit("set_pageSize", e)
}

onBeforeMount(()=>{
  selectedOption.value = props.pagePerItems;
})

</script>

<template>
  <v-select
      class="my-select"
      v-model="selectedOption"
      :items="pageOption"
      label="pageSize"
      hide-details
      width="120"
      @update:modelValue="updateNumItems"
      variant="plain"
      density="compact"
      center-affix
  ></v-select>
</template>

<style scoped>



</style>
